export const route = [
  {
    key: 'supply',
    name: 'menus.supplyManagement',
    icon: 'hi-puzzle-piece-icon',
    route: {
      name: 'trucker-id-supply-list'
    },
    permissions: ['supply_management']
  }
]
